import styles from "./AccordianTable.styles";

export const COLUMNS = [
  // {
  //   heading: "MEMBER DETAILS",
  //   style: styles.column3,
  // },
  {
    heading: "DIVISION",
    style: styles.column2,
  },
  {
    heading: "ADDRESS AND STRUCTURE",
    style: styles.column3,
  },
  {
    heading: "INITIATOR SI DETAILS",
    style: styles.column2,
  },
  {
    heading: "",
    style: styles.noColumn,
  },
  {
    heading: "ADDRESS AND STRUCTURE",
    style: styles.column3,
  },
  {
    heading: "TARGET SI",
    style: styles.column2,
  },
  {
    heading: "INTRODUCED BY",
    style: styles.column2,
  },
  {
    heading: "ACTION",
    style: styles.column2,
  },
  // {
  //   heading: "Organisation Structure",
  //   style: styles.column3,
  // },
  // {
  //   heading: "AREA",
  //   style: styles.column,
  // },
  // {
  //   heading: "ZONE",
  //   style: styles.column,
  // },
  // {
  //   heading: "REGION",
  //   style: styles.column,
  // },
  // {
  //   heading: "CHAPTER",
  //   style: styles.column,
  // },
  // {
  //   heading: "DISTRICT",
  //   style: styles.column,
  // },
];
